"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShippingOfferSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _models = require("../../models");
var _sharedStyles = require("../shippingOffer/sharedStyles");
var _ShippingOfferItemSkeleton = require("./ShippingOfferItemSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const Items = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return (0, _sharedStyles.gridStyles)(theme);
});
const ShippingOfferSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { isDoubleCurrency } = (0, _contexts.useCheckoutDeliveryContext)();
    const getItemProps = (opacity)=>({
            isDoubleCurrency,
            opacity
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Items, {
        "data-testid": getTestId(_models.TestId.ShippingOfferSkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOfferItemSkeleton.ShippingOfferItemSkeleton, {
                ...getItemProps(1)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOfferItemSkeleton.ShippingOfferItemSkeleton, {
                ...getItemProps(0.75)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ShippingOfferItemSkeleton.ShippingOfferItemSkeleton, {
                ...getItemProps(0.5)
            })
        ]
    });
};
exports.ShippingOfferSkeleton = ShippingOfferSkeleton;
